<div class="legend-container" *ngIf="!!dataSource.length && data?.showLegend">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: #dceaf7"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: #f2f2f2"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="table-wrapper" [class.fullscreen-table-wrapper]="isFullScreen"
  [style.height]="isFullScreen ? '100%' : (data?.height || data?.chartConfig?.height || 'auto')">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="table-scroll-container" *ngIf="!isLoading && !dataSource.length">
    <div class="table-content-wrapper" style="padding: 16px; text-align: center; color: #666;">
      {{ noDataText }}
    </div>
  </div>

  <div class="table-actions-menu" *ngIf="!!dataSource.length">
    <button mat-icon-button [matMenuTriggerFor]="tableMenu" class="table-menu-trigger" disableRipple>
      <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #tableMenu="matMenu">
      <button mat-menu-item (click)="downloadCsv()">
        <mat-icon>file_download</mat-icon>
        <span>Export</span>
      </button>
      <button mat-menu-item (click)="onToggleFullscreen()">
        <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        <span>{{ isFullScreen ? 'Exit Fullscreen' : 'Fullscreen' }}</span>
      </button>
    </mat-menu>
  </div>

  <div class="table-scroll-container" *ngIf="!!dataSource.length">
    <div class="table-content-wrapper">

      <!-- ① Native HTML table for year/group headers — plain CSS sticky works here without AM interference -->
      <table *ngIf="hasGroupedHeaders" class="grouped-header-table">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]">
        </colgroup>
        <tr>
          <th *ngFor="let group of headerGroups; let i = index" class="grouped-header-cell"
            [attr.colspan]="group.colspan || group.columns.length || 1" [class.sticky-column]="isSpacerGroup(group)"
            [class.selected-header]="isGroupHeaderSelected(group.label)"
            [class.single-quarter-year-header]="isSingleQuarterYearGroup(group)"
            [class.clickable-header]="!!group.label && !isQuarterlyIdentifierGroup(group)"
            [class.quarterly-static-group]="isQuarterlyIdentifierGroup(group)" [style.width.px]="getGroupWidthPx(group)"
            [style.min-width.px]="getGroupWidthPx(group)" [style.left.px]="getGroupLeft(group)"
            [style.border-left]="i === 1 ? '1px solid #333' : ''" [style.border-right]="i === 1 ? '1px solid #333' : ''"
            (click)="isQuarterlyIdentifierGroup(group) ? null : onGroupHeaderClick(group, $event)">
            {{ group.label }}
            <span class="sort-indicator" *ngIf="!!group.label && sortColumn === group.label">

            </span>
          </th>
        </tr>
      </table>

      <!-- ② Angular Material table — data + column header row only -->
      <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource" class="custom-table resizable-table">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]">
        </colgroup>

        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" [sticky]="isStickyColumn(column)">
          <th class="tableheader" mat-header-cell *matHeaderCellDef
            [class.clickable-header]="!isQuarterlyIdentifierColumn(column)"
            [class.sticky-column]="isStickyColumn(column)" [class.selected-header]="isColumnHeaderSelected(column)"
            [style.width.px]="columnWidths[column]" [style.min-width.px]="columnWidths[column]"
            [style.max-width.px]="columnWidths[column]" [style.position]="isStickyColumn(column) ? 'sticky' : ''"
            (mousedown)="onHeaderMouseDown($event, column)" [style.left.px]="getStickyColumnLeft(column)"
            [style.z-index]="getStickyColumnZIndex(column, true)"
            [style.border-left]="column === 'channel_type' ? '1px solid #2f2f2f' : ''"
            [style.border-right]="column === 'channel_type' ? '1px solid #2f2f2f' : ''"
            [style.box-shadow]="column === 'channel_type' ? 'none' : ''"
            (click)="isQuarterlyIdentifierColumn(column) ? null : onColumnHeaderClick(column, $event)">
            <span class="header-label">{{ columnLabels[column] }}</span>
            <span class="sort-indicator" *ngIf="sortColumn === column">

            </span>
            <div class="resize-handle" (mousedown)="onResizeStart($event, column)" (click)="$event.stopPropagation()">
            </div>
          </th>
          <td class="tablebody" mat-cell *matCellDef="let row" [style.width.px]="columnWidths[column]"
            [style.min-width.px]="columnWidths[column]" [style.max-width.px]="columnWidths[column]"
            (click)="onCellClick(row, column, $event)" [class.sticky-column]="isStickyColumn(column)"
            [style.position]="isStickyColumn(column) ? 'sticky' : ''" [style.left.px]="getStickyColumnLeft(column)"
            [style.z-index]="getStickyColumnZIndex(column)"
            [style.border-left]="column === 'channel_type' ? '1px solid #e0e0e0' : ''"
            [style.border-right]="column === 'channel_type' ? '1px solid #e0e0e0' : ''"
            [style.box-shadow]="column === 'channel_type' ? 'none' : ''"
            [class.selected-cell]="isCellSelected(row, column) && !isIdentifierColumn(column)"
            [class.numerical-cell]="!isIdentifierColumn(column)"
            [class.highlighted-column]="isColumnHighlightedByCell(column) || isColumnHighlighted(column)">
            {{ row[column] }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" [ngClass]="{
              'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
              'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers',
              'even-row': i % 2 === 0,
                'odd-row': i % 2 !== 0,
              'selected-row': isRowHighlighted(row)
            }"></tr>
      </table>
    </div>
  </div>
  @if (!!data?.isPagination && !!dataSource.length ) {
  <div class="table-footer">
    <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
  </div>
  }
</div>
